import { useSiteSettings } from '@monorepo/site-settings';

const useGetPersonalOfficeMenu = () => {
  const { personalOfficeMenu = [] } = useSiteSettings();

  return personalOfficeMenu;
};

export default useGetPersonalOfficeMenu;
